<template>
  <div class="system-page">
    <div class="section">
      <h3>系统信息</h3>
      <div class="info-grid">
        <div class="info-item">
          <label>系统版本</label>
          <span>v1.0.0</span>
        </div>
        <div class="info-item">
          <label>运行环境</label>
          <span>Development</span>
        </div>
        <div class="info-item">
          <label>数据库</label>
          <span>MySQL 8.0</span>
        </div>
        <div class="info-item">
          <label>服务端口</label>
          <span>8080</span>
        </div>
      </div>
    </div>

    <div class="section">
      <h3>基础设置</h3>
      <form class="setting-form">
        <div class="form-row">
          <label>平台名称</label>
          <input v-model="settings.platformName" type="text" class="form-control" />
        </div>
        <div class="form-row">
          <label>客服电话</label>
          <input v-model="settings.servicePhone" type="text" class="form-control" />
        </div>
        <div class="form-row">
          <label>服务时间</label>
          <input v-model="settings.serviceTime" type="text" class="form-control" placeholder="如：08:00-22:00" />
        </div>
        <div class="form-actions">
          <button type="button" @click="saveSettings" class="btn-save">保存设置</button>
        </div>
      </form>
    </div>

    <div class="section">
      <h3>通知设置</h3>
      <div class="toggle-group">
        <div class="toggle-item">
          <span class="toggle-label">新订单通知</span>
          <label class="toggle-switch">
            <input v-model="notifications.newOrder" type="checkbox" />
            <span class="slider"></span>
          </label>
        </div>
        <div class="toggle-item">
          <span class="toggle-label">订单状态变更通知</span>
          <label class="toggle-switch">
            <input v-model="notifications.orderStatus" type="checkbox" />
            <span class="slider"></span>
          </label>
        </div>
        <div class="toggle-item">
          <span class="toggle-label">跑腿员认证通知</span>
          <label class="toggle-switch">
            <input v-model="notifications.runnerCert" type="checkbox" />
            <span class="slider"></span>
          </label>
        </div>
        <div class="toggle-item">
          <span class="toggle-label">系统消息推送</span>
          <label class="toggle-switch">
            <input v-model="notifications.system" type="checkbox" />
            <span class="slider"></span>
          </label>
        </div>
      </div>
      <div class="form-actions">
        <button type="button" @click="saveNotifications" class="btn-save">保存通知设置</button>
      </div>
    </div>

    <div class="section">
      <h3>数据管理</h3>
      <div class="action-grid">
        <button @click="backupData" class="action-card">
          <div class="action-icon">📦</div>
          <div class="action-text">备份数据</div>
        </button>
        <button @click="clearCache" class="action-card">
          <div class="action-icon">🗑️</div>
          <div class="action-text">清除缓存</div>
        </button>
        <button @click="exportData" class="action-card">
          <div class="action-icon">📊</div>
          <div class="action-text">导出数据</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'System',
  data() {
    return {
      settings: {
        platformName: '贞吉跑腿',
        servicePhone: '400-123-4567',
        serviceTime: '08:00-22:00'
      },
      notifications: {
        newOrder: true,
        orderStatus: true,
        runnerCert: true,
        system: true
      }
    }
  },
  methods: {
    saveSettings() {
      alert('设置已保存')
    },
    saveNotifications() {
      alert('通知设置已保存')
    },
    backupData() {
      alert('数据备份功能开发中')
    },
    clearCache() {
      if (confirm('确定要清除缓存吗？')) {
        alert('缓存已清除')
      }
    },
    exportData() {
      alert('数据导出功能开发中')
    }
  }
}
</script>

<style scoped>
.system-page {
  padding: 20px;
}

.section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.section h3 {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #333;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.info-item label {
  font-size: 14px;
  color: #999;
}

.info-item span {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.setting-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.form-row label {
  width: 120px;
  font-size: 14px;
  color: #666;
}

.form-control {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.form-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.btn-save {
  padding: 10px 20px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.toggle-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.toggle-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.toggle-label {
  font-size: 14px;
  color: #333;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 26px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 26px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #3498db;
}

input:checked + .slider:before {
  transform: translateX(22px);
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.action-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: background 0.3s;
}

.action-card:hover {
  background: #e9ecef;
}

.action-icon {
  font-size: 32px;
  margin-bottom: 10px;
}

.action-text {
  font-size: 14px;
  color: #333;
}
</style>
